<template>
    <v-container ma-0 pa-0 class="landing-page-wrapper w-100 h-100">
        <v-row class="h-100">
            <v-col cols="12" lg="6" class="h-100 p-0 carousel-wrapper">
                <div class="d-flex flex-column h-100 mx-auto justify-content-center align-items-center">
                    <div class="mb-5">
                        <v-img src="images/britannia-logo.png" class="carousel-wrapper-logo" width="200px"></v-img>
                    </div>
                </div>
            </v-col>

            <v-col class="landing-buttons-wrapper h-100 p-0 carousel-component" cols="12" lg="6">
                <a class="bgo-landing-btn" :href="loginUrl">{{ t('default::landing.button.signin') }}</a>
                <a v-if="can('auth.register')" class="bgo-landing-btn" :href="registrationUrl">{{
                    t('default::landing.button.register')
                }}</a>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    computed: {
        loginUrl() {
            return route('auth.login');
        },
        registrationUrl() {
            return route('auth.register');
        },
    },
};
</script>
